/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Calendar_Microsoft_SubInputs */



/**
* | output |
* | --- |
* | "Outlook calendar · Teams" |
*
* @param {Onboarding_Calendar_Microsoft_SubInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_calendar_microsoft_sub = /** @type {((inputs?: Onboarding_Calendar_Microsoft_SubInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Calendar_Microsoft_SubInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Outlook-agenda · Teams")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agenda Outlook · Teams")
	return /** @type {LocalizedString} */ ("Outlook calendar · Teams")
});